var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isLoggedIn && _vm.promotionsEnabled && _vm.getApplicableVouchers
    ? _c(
        "div",
        { staticClass: "promotion-vouchers" },
        _vm._l(_vm.applicableVouchers, function(voucher, index) {
          return _vm.applicableVouchers && _vm.applicableVouchers.length
            ? _c("promotion-voucher", {
                key: voucher.IDMMPRVoucher,
                attrs: {
                  index: index,
                  voucher: voucher,
                  betId: _vm.betId,
                  tab: _vm.betslipTab,
                  currentBetSlipState: _vm.currentBetSlipState
                },
                on: { dismissError: _vm.dismissError }
              })
            : _vm._e()
        }),
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-383e6884", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-383e6884","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/betslipV2/promotionVouchers/vouchers.vue
// module id = null
// module chunks = 